import {DataStatus} from 'platform/components';

import {isEmpty} from 'ramda';

import {useGetServiceCaseIntegrationsEvaClaimDetailQuery} from '@dms/api/workshop';

import {parseDate, TestIdProps} from 'shared/web';

import {EvaClaim} from './components/EvaClaim';

interface EvaClaimDialogProps extends TestIdProps {
  serviceCaseId: string;
  onClose: () => void;
}

export function EvaClaimDialog(props: EvaClaimDialogProps) {
  const {data, isLoading, isError} = useGetServiceCaseIntegrationsEvaClaimDetailQuery({
    serviceCaseId: props.serviceCaseId,
  });

  const defaultValues = {
    dealerClaimNumber: data?.dealerClaimNumber ?? undefined,
    repairStartDate: data?.repairStartDate ? parseDate(data?.repairStartDate) : undefined,
    repairEndDate: data?.repairEndDate ? parseDate(data?.repairEndDate) : undefined,
    mileageStart: data?.mileageStart ?? undefined,
    mileageEnd: data?.mileageEnd ?? undefined,
    claimText: data?.claimText ?? undefined,
    orders:
      data?.orders?.map((order) => ({
        serviceOrderId: order.serviceOrderId,
        isSelected: order.isSelected,
      })) ?? [],
  };

  return (
    <DataStatus isLoading={isLoading} isError={isError}>
      <EvaClaim
        defaultValues={defaultValues}
        dealerClaimNumberTooltip={
          !isEmpty(data?.dealerClaimNumberTooltip) ? data?.dealerClaimNumberTooltip : null
        }
        onClose={props.onClose}
        orders={data?.orders ?? []}
        serviceCaseId={props.serviceCaseId}
      />
    </DataStatus>
  );
}
